import $ from 'jquery'
import 'bootstrap'

export default defineNuxtPlugin(() => {
  ;(window as any).jQuery = (window as any).$ = $

  return {
    provide: {
      jquery: $
    }
  }
})
